module.exports = __webpack_public_path__ + "static/media/science_pie.f1d56a03.png";